const columns = ['bahai_idn', 'fullname', 'emailaddress1', 'emailaddress2'] as const;

export default { columns, fields: [] };
